import React from "react";
import { Form, Col } from 'react-bootstrap';
// import { X } from 'react-bootstrap-icons';
// import { render } from "@testing-library/react";
import { useDispatch } from 'redux-react-hook';
import ReactPlayer from "react-player"

export default function QuestionOptInputExternalVideo(props) {
    const { data, pid, onChange } = props;
    const questionIndex = props.index;
    const dispatch = useDispatch();

    function onLnkChange(e) {
        console.log(e.target.value)
        props.onKeyChange("lnk", e.target.value);
    }

    function handleKeyPress(e) {
        const char = e.charCode;
        // console.log(char);
        if (13 == char) { //enter
            dispatch({ type: "ON_ADD_TMP_OPTION", index: questionIndex });
        }
    }

    function render() {
        return (
            <>
                <input type="text" className="w-100 underline mb-1" value={data.na} onChange={onChange} onKeyPress={handleKeyPress} />

                <Form.Group>
                    <Form>
                        <Form.Row>
                            <Form.Label column xs="3">影片連結:</Form.Label>
                            <Col className="text-left">
                                <Form.Control onChange={onLnkChange} type="text" value={data.lnk} />
                            </Col>
                        </Form.Row>
                    </Form>
                </Form.Group>
                {data.lnk ? (
                    <div className="mb-2">
                        <ReactPlayer
                            height={"112px"}
                            width={"200px"}
                            url={data.lnk}
                        />
                        {/* <video src={data} style={{"max-height":"80px", "max-width":"200px"}}/> */}
                    </div>
                ) : null}
            </>
        );
    }

    return render();
}